import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import useCreate from "../../useCreate";
import toast from "react-hot-toast";

const useCreateAttributeValue = ({ reset, onValueCreated }) => {
  const { attributeValueId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();

  const { setDataToServer } = useCreate({
    url: "product/attribute-value/create",
    refreshUrl: "product/attribute/list",
    onSuccess: (response) => {
      // Pass the new attribute_value_id to the callback
      if (onValueCreated && response?.attribute_value_id) {
        onValueCreated(response.attribute_value_id);
      }

      // Debug: Log all active queries to see what's in cache
      console.log(
        "All active queries:",
        queryClient
          .getQueryCache()
          .getAll()
          .map((q) => q.queryKey)
      );

      // Invalidate all attribute-related queries to ensure fresh data
      queryClient.invalidateQueries({
        predicate: (query) => {
          return (
            query.queryKey[0] === "product/attribute/list" ||
            query.queryKey[0] === "getAttributeList" ||
            query.queryKey.includes("product/attribute/list") ||
            query.queryKey.includes("getAttributeList")
          );
        },
      });

      queryClient.refetchQueries({ queryKey: ["product/attribute/list"] });
      queryClient.refetchQueries({ queryKey: ["getAttributeList"] });

      if (searchParams.get("mode") === "edit") {
        navigate(`/catalog/variants/attribute-values`);
      } else {
        reset?.();
      }
      toast.success("Attribute Value Added Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const handleSubmit = (data) => {
    let finalFormData;
    if (attributeValueId) {
      finalFormData = {
        ...data,
        attribute_value_id: attributeValueId,
      };
    } else {
      finalFormData = data;
    }
    setDataToServer.mutate(finalFormData);
  };

  return { handleSubmit };
};

export default useCreateAttributeValue;
